import { render, staticRenderFns } from "./TooManyRequestedError.vue?vue&type=template&id=5cee46b8&scoped=true&"
import script from "./TooManyRequestedError.vue?vue&type=script&lang=ts&"
export * from "./TooManyRequestedError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee46b8",
  null
  
)

export default component.exports